type BrandLogoProps = {
  className?: string;
  size?: number;
  alt?: string;
};

/** Micus star-rise mark — transparent PNG from /logo.png */
export default function BrandLogo({
  className = '',
  size = 32,
  alt = 'Micus',
}: BrandLogoProps) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      width={size}
      height={size}
      className={`block select-none object-contain ${className}`}
      draggable={false}
    />
  );
}
